module.exports = __webpack_public_path__ + "img/success-2.b16489f6.svg";